import type { FC } from 'react';

import { ClubCurrencyIconV2 as ClubCurrencyIcon } from '@wwe-portal/ui/components/icons';
import { PickemIcon } from '@wwe-portal/ui/components/icons/pickem-icon';
import { RubyIcon } from '@wwe-portal/ui/components/icons/ruby-icon';
import { WebCoinIcon } from '@wwe-portal/ui/components/icons/web-coin-icon';
import { cn } from '@wwe-portal/ui/lib/lib';

import { CurrencyType } from '@wwe-portal/entities/currency.type';

const WEB_CURRENCY_ITEMS: Record<CurrencyType, React.JSX.Element> = {
  [CurrencyType.Pickem]: <PickemIcon className="size-full cursor-pointer" />,
  [CurrencyType.Ruby]: <RubyIcon className="size-full cursor-pointer" />,
  [CurrencyType.ClubCoin]: (
    <ClubCurrencyIcon className="text-goldtier size-full cursor-pointer" />
  ),
  [CurrencyType.WebCoin]: <WebCoinIcon className="size-full cursor-pointer" />,
};

export const MilestoneItemIcon: FC<{
  imgUrl?: string;
  currencyType?: CurrencyType;
  isClaimed: boolean;
  displayPoint: number;
  className?: string;
}> = ({ imgUrl, currencyType, isClaimed, displayPoint, className }) => {
  if (imgUrl)
    return (
      <img
        alt="logo"
        className={cn(
          {
            'opacity-50 grayscale': Boolean(displayPoint) && isClaimed,
          },
          'cursor-pointer object-contain',
          className
        )}
        src={imgUrl}
      />
    );
  return (
    <div
      className={cn(
        {
          'opacity-50 grayscale': Boolean(displayPoint) && isClaimed,
        },
        'cursor-pointer object-contain',
        className
      )}
    >
      {currencyType && WEB_CURRENCY_ITEMS[currencyType]}
    </div>
  );
};
